/**
 * WordPress dependencies
 */
import { useMemo } from '@wordpress/element';
/**
 * @type {WeakMap<any, number>}
 */

var instanceMap = new WeakMap();
/**
 * Creates a new id for a given object.
 *
 * @param {unknown} object Object reference to create an id for.
 * @return {number} The instance id (index).
 */

function createId(object) {
  var instances = instanceMap.get(object) || 0;
  instanceMap.set(object, instances + 1);
  return instances;
}
/**
 * Provides a unique instance ID.
 *
 * @param {Object} object Object reference to create an id for.
 * @param {string} prefix Prefix for the unique id.
 * @param {string} preferredId Default ID to use.
 * @return {string | number} The unique instance id.
 */


export default function useInstanceId(object, prefix) {
  var preferredId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return useMemo(function () {
    if (preferredId) return preferredId;
    var id = createId(object);
    return prefix ? "".concat(prefix, "-").concat(id) : id;
  }, [object]);
}
//# sourceMappingURL=index.js.map